export default "__VITE_ASSET__DQ_kBJ8___"